import { render, staticRenderFns } from "./chinaMap.vue?vue&type=template&id=62397d9b"
import script from "./chinaMap.vue?vue&type=script&lang=js"
export * from "./chinaMap.vue?vue&type=script&lang=js"
import style0 from "./chinaMap.vue?vue&type=style&index=0&id=62397d9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports